/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// global camping constants
export const CAMP_BASEPATH = '/camps';
export const CAMPING_BASEPATH = '/camping';
export const CAMPING_INTERNAL_BASEPATH = '/internal/camping';
export const RENTAL_BASEPATH = '/rentals';
export const AVAIL_ALERT_BASEPATH = '/availabilitynotification';
export const RATING_REVIEW_BASEPATH = '/ratingreview';

// recaptcha
export const CHALLENGE_ENTERPRISE_REGION = 'ENTERPRISE';

// campground
export const GET_CAMPGROUND = 'GET_CAMPGROUND';
export const GET_CAMPGROUND_ERROR = 'GET_CAMPGROUND_ERROR';
export const GET_CAMPGROUND_RATES = 'GET_CAMPGROUND_RATES';
export const GET_CAMPGROUND_RATES_ERROR = 'GET_CAMPGROUND_RATES_ERROR';
export const GET_CAMPGROUND_SCHEDULES = 'GET_CAMPGROUND_SCHEDULES';
export const GET_CAMPGROUND_SCHEDULES_ERROR = 'GET_CAMPGROUND_SCHEDULES_ERROR';
export const GET_CAMPGROUND_SEARCH_RESULT = 'GET_CAMPGROUND_SEARCH_RESULT';
export const GET_CAMPGROUND_RECREATION_SITES = 'GET_CAMPGROUND_RECREATION_SITES';
export const GET_CAMPGROUND_RECREATION_SITES_ERROR =
    'GET_CAMPGROUND_RECREATION_SITES_ERROR';
export const GET_CAMPGROUND_TYPE_OF_USE = 'GET_CAMPGROUND_TYPE_OF_USE';
export const GET_RELEASE_DATES = 'GET_RELEASE_DATES';
export const GET_RELEASE_DATES_ERROR = 'GET_RELEASE_DATES_ERROR';
export const GET_CAMPGROUND_SITE_TYPES_COUNT = 'GET_CAMPGROUND_SITE_TYPES_COUNT';
export const GET_CAMPGROUND_SITE_TYPES_COUNT_ERROR =
    'GET_CAMPGROUND_SITE_TYPES_COUNT_ERROR';
export const GET_CAMPGROUND_GALLERY = 'GET_CAMPGROUND_GALLERY';
export const GET_CAMPGROUND_AVAILABILITY = 'GET_CAMPGROUND_AVAILABILITY';
export const GET_CAMPGROUND_AVAILABILITY_ERROR = 'GET_CAMPGROUND_AVAILABILITY_ERROR';
export const SET_CALENDAR_COUNTS_AVAILABILITY = 'SET_CALENDAR_COUNTS_AVAILABILITY';
export const FETCH_MONTHLY_AVAILABILITY = 'FETCH_MONTHLY_AVAILABILITY';
export const FETCH_MONTHLY_AVAILABILITY_SUCCESS = 'FETCH_MONTHLY_AVAILABILITY_SUCCESS';
export const SET_RATE_LIMITED_MONTHS = 'SET_RATE_LIMITED_MONTHS';
export const CLEAR_RATE_LIMITED_MONTHS = 'CLEAR_RATE_LIMITED_MONTHS';
export const SET_AVAILABILITY_QUERY_ENABLED = 'SET_AVAILABILITY_QUERY_ENABLED';

// digital passes
export const FETCH_DIGITAL_PASSES_SUCCESS = 'FETCH_DIGITAL_PASSES_SUCCESS';
export const FETCH_DIGITAL_PASSES_ERROR = 'FETCH_DIGITAL_PASSES_ERROR';
export const FETCH_DIGITAL_PASSES_LOADING = 'FETCH_DIGITAL_PASSES_LOADING';

// availAlert
export const GET_AVILALERTS_SUMMARY_ACTIVE = 'GET_AVILALERTS_SUMMARY_ACTIVE';
export const GET_AVILALERTS_SUMMARY_INACTIVE = 'GET_AVILALERTS_SUMMARY_INACTIVE';
export const GET_AVILALERTS_SUMMARY_ERROR = 'GET_AVILALERTS_SUMMARY_ERROR';
export const GET_AVAILALERT_COUNTS = 'GET_AVAILALERT_COUNTS';
export const GET_AVAILALERT_COUNTS_ERROR = 'GET_AVAILALERT_COUNTS_ERROR';
export const GET_AVAILALERTS = 'GET_AVAILALERTS';
export const GET_AVAILALERTS_ERROR = 'GET_AVAILALERTS_ERROR';
export const GET_AVAILALERTS_LOADING = 'GET_AVAILALERTS_LOADING';
export const UPDATE_AVAILALERT = 'UPDATE_AVAILALERT';
export const UPDATE_AVAILALERT_ERROR = 'UPDATE_AVAILALERT_ERROR';
export const DEACTIVATE_AVAILALERT = 'DEACTIVATE_AVAILALERT';
export const DEACTIVATE_AVAILALERT_ERROR = 'DEACTIVATE_AVAILALERT_ERROR';
export const DEACTIVATE_AVAILALERT_LOADING = 'DEACTIVATE_AVAILALERT_LOADING';
export const DELETE_AVAILALERT = 'DELETE_AVAILALERT';
export const DELETE_AVAILALERT_ERROR = 'DELETE_AVAILALERT_ERROR';
export const DELETE_AVAILALERT_LOADING = 'DELETE_AVAILALERT_LOADING';
export const CREATE_AVAILALERT = 'CREATE_AVAILALERT';
export const CREATE_AVAILALERT_ERROR = 'CREATE_AVAILALERT_ERROR';

// availabilityGrid
export const INIT_CAMPGROUND_AVAILABILITY_STATES = 'INIT_CAMPGROUND_AVAILABILITY_STATES';
export const FILTER_AVAILABILITY_DATA = 'FILTER_AVAILABILITY_DATA';
export const FILTER_AVAILABILITY_DATA_ERROR = 'FILTER_AVAILABILITY_DATA_ERROR';
export const FETCH_AVAILABILITY_DATA_SUCCESS = 'FETCH_AVAILABILITY_DATA_SUCCESS';
export const FETCH_AVAILABILITY_DATA_FAILURE = 'FETCH_AVAILABILITY_DATA_FAILURE';
export const FILTER_AVAILABILITIES_BY_SEARCH_COMPLETE =
    'FILTER_AVAILABILITIES_BY_SEARCH_COMPLETE';
export const SET_FILTER_INPUT = 'SET_FILTER_INPUT';
export const FILTER_AVAILABILITIES_BY_INPUT_COMPLETE =
    'FILTER_AVAILABILITIES_BY_INPUT_COMPLETE';
export const UPDATE_AVAILABILITIES_COMPLETE = 'UPDATE_AVAILABILITIES_COMPLETE';
export const UPDATE_SINGLE_CAMPSITE_AVAILABILITIES_COMPLETE =
    'UPDATE_SINGLE_CAMPSITE_AVAILABILITIES_COMPLETE';
export const SET_SORT_PROPERTY = 'SET_SORT_PROPERTY';
export const SORT_AVAILABILITIES_COMPLETE = 'SORT_AVAILABILITIES_COMPLETE';
export const COMPILE_FINAL_DISPLAYABLE_AVAILABILITIES =
    'COMPILE_FINAL_DISPLAYABLE_AVAILABILITIES';
export const SET_GRID_RANGE = 'SET_GRID_RANGE';
export const SET_GRID_SIZE = 'SET_GRID_SIZE';
export const PROCESS_AVAILABILITY_COMPLETE = 'PROCESS_AVAILABILITY_COMPLETE';
export const UPDATE_SELECTIONS = 'UPDATE_SELECTIONS';
export const UPDATE_SELECTION_BY_ID = 'UPDATE_SELECTION_BY_ID';
export const UPDATE_SELECTION_WITH_RES_ID = 'UPDATE_SELECTION_WITH_RES_ID';
export const CLEAR_SELECTIONS = 'CLEAR_SELECTIONS';
export const UPDATE_ESTIMATED_PRICE = 'UPDATE_ESTIMATED_PRICE';
export const PAUSE_LOADING = 'PAUSE_LOADING';
export const CONTINUE_LOADING = 'CONTINUE_LOADING';
export const OPEN_RENTAL_MODAL = 'OPEN_RENTAL_MODAL';
export const CLOSE_RENTAL_MODAL = 'CLOSE_RENTAL_MODAL';
export const OPEN_ACCESSIBILITY_MODAL = 'OPEN_ACCESSIBILITY_MODAL';
export const CLOSE_ACCESSIBILITY_MODAL = 'CLOSE_ACCESSIBILITY_MODAL';
export const OPEN_CAMPGROUND_FILTERS_MODAL = 'OPEN_CAMPGROUND_FILTERS_MODAL';
export const CLOSE_CAMPGROUND_FILTERS_MODAL = 'CLOSE_CAMPGROUND_FILTERS_MODAL';
export const OPEN_ITINERARY_DETAILS_MODAL = 'OPEN_ITINERARY_DETAILS_MODAL';
export const CLOSE_ITINERARY_DETAILS_MODAL = 'CLOSE_ITINERARY_DETAILS_MODAL';
export const COMPLETE_RESERVATION_CREATIONS_FAILURE =
    'COMPLETE_RESERVATION_CREATIONS_FAILURE';
export const FETCH_CAMPSITES_AVAILABILITY = 'FETCH_CAMPSITES_AVAILABILITY';
export const FETCH_CAMPSITES_AVAILABILITY_LOADING =
    'FETCH_CAMPSITES_AVAILABILITY_LOADING';
export const SELECT_LTS_CAMPSITE = 'SELECT_LTS_CAMPSITE';
export const CLEAR_LTS_CAMPSITE = 'CLEAR_LTS_CAMPSITE';
export const RESERVATION_DETAILS_TOGGLE = 'RESERVATION_DETAILS_TOGGLE';
export const CLEAR_CAMPSITE_AVAILABILITY = 'CLEAR_CAMPSITE_AVAILABILITY';

// pagination
export const PAGINATION_SIZE = 40;
export const CAMPSITE_LISTING_PAGINATION_SIZE = 10;

// campsite
export const GET_CAMPSITE = 'GET_CAMPSITE';
export const GET_CAMPSITE_ERROR = 'GET_CAMPSITE_ERROR';
export const GET_CAMPSITES = 'GET_CAMPSITES';
export const GET_CAMPSITES_ERROR = 'GET_CAMPSITES_ERROR';
export const GIS_SETUP_GEOCAMPSITES = 'GIS_SETUP_GEOCAMPSITES';

export const FETCHING_CAMPSITES_START = 'FETCHING_CAMPSITES_START';
export const GET_AVAILABLE_CAMPSITES = 'GET_AVAILABLE_CAMPSITES';
export const GET_AVAILABLE_CAMPSITES_ERROR = 'GET_AVAILABLE_CAMPSITES_ERROR';
export const CLEAR_GET_AVAILABLE_CAMPSITES_ERROR = 'CLEAR_GET_AVAILABLE_CAMPSITES_ERROR';
export const FETCHING_V3_CAMPSITES_START = 'FETCHING_V3_CAMPSITES_START';
export const GET_V3_AVAILABLE_CAMPSITES = 'GET_V3_AVAILABLE_CAMPSITES';
export const GET_V3_AVAILABLE_CAMPSITES_ERROR = 'GET_V3_AVAILABLE_CAMPSITES_ERROR';
export const SET_V3_FLEXIBLE_SEARCH_PARAMS = 'SET_V3_FLEXIBLE_SEARCH_PARAMS';
export const CLEAR_V3_FLEXIBLE_SEARCH_PARAMS = 'CLEAR_V3_FLEXIBLE_SEARCH_PARAMS';
export const GET_AVAILABLE_PRICE_ERROR = 'GET_AVAILABLE_PRICE_ERROR';
export const GET_RESERVATION_PRICE_DETAILS = 'GET_RESERVATION_PRICE_DETAILS';
export const GET_RESERVATION_PRICE_DETAILS_ERROR = 'GET_RESERVATION_PRICE_DETAILS_ERROR';
export const GET_CAMPSITE_LIST = 'GET_CAMPSITE_LIST';
export const GET_CAMPSITE_LIST_ERROR = 'GET_CAMPSITE_LIST_ERROR';
export const CAMPSITE_CHANGE_STATUS = 'CAMPSITE_CHANGE_STATUS';
export const GET_ORDER_PRICE = 'GET_ORDER_PRICE';
export const GET_ORDER_PRICE_ERROR = 'GET_ORDER_PRICE_ERROR';
export const GET_UNFILTERED_CAMPSITES_COUNT = 'GET_UNFILTERED_CAMPSITES_COUNT';

// search
export const GET_SEARCH_WHERE_SUGGESTIONS = 'GET_SEARCH_WHERE_SUGGESTIONS';
export const GET_SEARCH_WHAT_SUGGESTIONS = 'GET_SEARCH_WHAT_SUGGESTIONS';

export const GET_SEARCH_RECAREA = 'GET_SEARCH_RECAREA';
export const GET_SEARCH_RECAREA_ERROR = 'GET_SEARCH_RECAREA_ERROR';
export const GET_SEARCH_RECAREA_NAME = 'GET_SEARCH_RECAREA_NAME';
export const GET_SEARCH_RECAREA_NAME_ERROR = 'GET_SEARCH_RECAREA_NAME_ERROR';

export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const GET_SEARCH_ERROR = 'GET_SEARCH_ERROR';
export const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';
export const ADD_SEARCH_FILTER = 'ADD_SEARCH_FILTER';
export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
export const REMOVE_SEARCH_FILTER = 'REMOVE_SEARCH_FILTER';
export const RESET_SEARCH_FILTERS = 'RESET_SEARCH_FILTERS';
export const GET_SEARCH_GLOBAL_AGREGATIONS = 'GET_SEARCH_GLOBAL_AGREGATIONS';
export const HIGHLIGHT_SEARCH_RESULT_ITEM = 'HIGHLIGHT_SEARCH_RESULT_ITEM';

export const UPDATE_CHECKIN_DATE = 'UPDATE_CHECKIN_DATE';
export const UPDATE_CHECKOUT_DATE = 'UPDATE_CHECKOUT_DATE';

// campsite availability API calls
export const CAMPSITE_AVAILABILITY_ALL_SUCCESS = 'CAMPSITE_AVAILABILITY_ALL_SUCCESS';
export const CAMPSITE_AVAILABILITY_DATE_RANGE_STARTED =
    'CAMPSITE_AVAILABILITY_DATE_RANGE_STARTED';
export const CAMPSITE_AVAILABILITY_DATE_RANGE_SUCCESS =
    'CAMPSITE_AVAILABILITY_DATE_RANGE_SUCCESS';
export const CAMPSITE_AVAILABILITY_DATE_RANGE_FAIL =
    'CAMPSITE_AVAILABILITY_DATE_RANGE_FAIL';

// selected card
export const CAMPSITE_AVAILABILITY_DESELECTED_CARD =
    'CAMPSITE_AVAILABILITY_DESELECTED_CARD';
export const CAMPSITE_AVAILABILITY_SELECTED_CARD = 'CAMPSITE_AVAILABILITY_SELECTED_CARD';

// map campsite ids selected
export const TOGGLE_FILTER_AS_YOU_MOVE = 'TOGGLE_FILTER_AS_YOU_MOVE';
export const MAP_CAMPSITE_IDS_SELECTED = 'MAP_CAMPSITE_IDS_SELECTED';
export const MAP_CAMPSITE_IDS_DESELECTED = 'MAP_CAMPSITE_IDS_DESELECTED';
export const RESET_MAP_VIEW = 'RESET_MAP_VIEW';

// navbar
export const SHOW_SEARCH = 'SHOW_SEARCH';
export const HIDE_SEARCH = 'HIDE_SEARCH';

// checkout
export const GET_CHECKOUT = 'GET_CHECKOUT';

// campground results page
export const GET_AVAILABLE_CAMPGROUND_SITES = 'GET_AVAILABLE_CAMPGROUND_SITES';

// reservations
export const GET_RESERVATION = 'GET_RESERVATION';
export const GET_RESERVATION_ERROR = 'GET_RESERVATION_ERROR';
export const GET_RESERVATIONS = 'GET_RESERVATIONS';
export const GET_RESERVATIONS_ERROR = 'GET_RESERVATIONS_ERROR';
export const GET_RESERVATION_REFUND = 'GET_RESERVATION_REFUND';
export const GET_RESERVATION_REFUND_ERROR = 'GET_RESERVATION_REFUND_ERROR';
export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const CREATE_RESERVATION_ERROR = 'CREATE_RESERVATION_ERROR';
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
export const UPDATE_RESERVATION_ERROR = 'UPDATE_RESERVATION_ERROR';
export const RESERVATION_UPDATE_STATUS = 'RESERVATION_UPDATE_STATUS';
export const RESERVATION_UPDATE_STATUS_ERROR = 'RESERVATION_UPDATE_STATUS_ERROR';
export const GET_RESERVATION_VIOLATIONS = 'GET_RESERVATION_VIOLATIONS';
export const GET_RESERVATION_VIOLATIONS_ERROR = 'GET_RESERVATION_VIOLATIONS_ERROR';
export const DELETE_RESERVATION = 'DELETE_RESERVATION';
export const DELETE_RESERVATION_ERROR = 'DELETE_RESERVATION_ERROR';
export const UNDO_RESERVATION_ERROR = 'UNDO_RESERVATION_ERROR';
export const CLEAR_RESERVATION_ERRORS = 'CLEAR_RESERVATION_ERRORS';
export const SAVE_RESERVATIONS = 'SAVE_RESERVATIONS';
export const GET_CART = 'GET_CART';
export const CREATE_RESERVATIONS = 'CREATE_RESERVATIONS';
export const CREATE_RESERVATIONS_ERROR = 'CREATE_RESERVATIONS_ERROR';
export const GET_CAMPING_PERMIT_PDF_ERROR = 'GET_CAMPING_PERMIT_PDF_ERROR';

// pending reservations
export const SET_ORDER_DETAILS_URL = 'SET_ORDER_DETAILS_URL';
export const PENDING_RESERVATION_PROP_CHANGE_REQUEST =
    'PENDING_RESERVATION_PROP_CHANGE_REQUEST';
export const PENDING_RESERVATION_PROP_CHANGED = 'PENDING_RESERVATION_PROP_CHANGED';
export const GET_PENDING_RESERVATION_PRICE_DETAILS =
    'GET_PENDING_RESERVATION_PRICE_DETAILS';
export const GET_PENDING_RESERVATION_PRICE_DETAILS_ERROR =
    'GET_PENDING_RESERVATION_PRICE_DETAILS_ERROR';
export const PENDING_RESERVATION_NEED_TO_KNOW_REQUEST =
    'PENDING_RESERVATION_NEED_TO_KNOW_REQUEST';
export const CLEAR_VALIDATION_ERRORS = 'CLEAR_VALIDATION_ERRORS';
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS';
export const REPROCESS_RESERVATION_SUCCESS = 'REPROCESS_RESERVATION_SUCCESS';
export const REPROCESS_RESERVATION_ERROR = 'REPROCESS_RESERVATION_ERROR';
export const PROCESS_ORDER_MODIFICATION = 'PROCESS_ORDER_MODIFICATION';
export const TRIGGER_ORDER_DETAILS_VALIDATION = 'TRIGGER_ORDER_DETAILS_VALIDATION';
export const UNTRIGGER_ORDER_DETAILS_VALIDATION = 'UNTRIGGER_ORDER_DETAILS_VALIDATION';
export const REMOVE_RESERVATION_FROM_CART = 'REMOVE_RESERVATION_FROM_CART';
export const REMOVE_RESERVATION_FROM_CART_ERROR = 'REMOVE_RESERVATION_FROM_CART_ERROR';
export const CONTROL_REMOVAL_MODAL = 'CONTROL_REMOVAL_MODAL';
export const TRIGGER_IS_REMOVING = 'TRIGGER_IS_REMOVING';
export const SET_SAVE_CHANGES_TO_ACCOUNT = 'SET_SAVE_CHANGES_TO_ACCOUNT';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const OPEN_PASS_CONFIRMATION_MODAL = 'OPEN_PASS_CONFIRMATION_MODAL';
export const CLOSE_PASS_CONFIRMATION_MODAL = 'CLOSE_PASS_CONFIRMATION_MODAL';
export const CONFIRM_PASS = 'CONFIRM_PASS';
export const COMPLETE_SUBMISSION_FAILURE = 'COMPLETE_SUBMISSION_FAILURE';
export const COMPLETE_SUBMISSION_SUCCESS = 'COMPLETE_SUBMISSION_SUCCESS';
export const CHANGE_ORDER_DETAILS_VIEW = 'CHANGE_ORDER_DETAILS_VIEW';
export const RESET_ORDER_DETAILS_STATE = 'RESET_ORDER_DETAILS_STATE';
export const CLEAR_ORDER_DETAILS_ERROR = 'CLEAR_ORDER_DETAILS_ERROR';
export const SET_CAN_MODIFY_AS_ITINERARY = 'SET_CAN_MODIFY_AS_ITINERARY';
export const SET_GROUP_SIZE_NOTIFICATION = 'SET_GROUP_SIZE_NOTIFICATION';
export const CLEAR_GROUP_SIZE_NOTIFICATION = 'CLEAR_GROUP_SIZE_NOTIFICATION';

// rental reservations
export const GET_RENTAL_RESERVATIONS = 'GET_RENTAL_RESERVATIONS';
export const GET_RENTAL_RESERVATIONS_ERROR = 'GET_RENTAL_RESERVATIONS_ERROR';
export const GET_RENTAL_RESERVATION = 'GET_RENTAL_RESERVATION';
export const GET_RENTAL_RESERVATION_ERROR = 'GET_RENTAL_RESERVATION_ERROR';

// lottery date info
export const GET_LOTTERY_DATE_INFO_ERROR = 'GET_LOTTERY_DATE_INFO_ERROR';
export const GET_LOTTERY_DATE_INFO = 'GET_LOTTERY_DATE_INFO';

/* =================== */
/*   Form Validation   */
/* =================== */
export const IS_INPUT_VALID = 'IS_INPUT_VALID';
export const IS_INPUT_ARRAY_VALID = 'IS_INPUT_ARRAY_VALID';
export const CLEAR_VALIDATION_ERROR = 'CLEAR_VALIDATION_ERROR';
export const RESET_VALIDATION_ERRORS = 'RESET_VALIDATION_ERRORS';

// recarea actions
export const GET_GATEWAY = 'GET_GATEWAY';
export const GET_GATEWAY_ERROR = 'GET_GATEWAY_ERROR';
export const GET_GATEWAY_CAMPGROUNDS = 'GET_GATEWAY_CAMPGROUNDS';
export const GET_GATEWAY_CAMPGROUNDS_ERROR = 'GET_GATEWAY_CAMPGROUNDS_ERROR';
export const GET_GATEWAY_PERMITS = 'GET_GATEWAY_PERMITS';
export const GET_GATEWAY_PERMITS_ERROR = 'GET_GATEWAY_PERMITS_ERROR';
export const GET_GATEWAY_TICKETS = 'GET_GATEWAY_TICKETS';
export const GET_GATEWAY_TICKETS_ERROR = 'GET_GATEWAY_TICKETS_ERROR';
export const GET_GATEWAY_DAYUSE = 'GET_GATEWAY_DAYUSE';
export const GET_GATEWAY_DAYUSE_ERROR = 'GET_GATEWAY_DAYUSE_ERROR';
export const GET_GATEWAY_POINTS_OF_INTEREST = 'GET_GATEWAY_POINTS_OF_INTEREST';
export const GET_GATEWAY_POINTS_OF_INTEREST_ERROR =
    'GET_GATEWAY_POINTS_OF_INTEREST_ERROR';
export const GET_POINT_OF_INTEREST = 'GET_POINT_OF_INTEREST';
export const GET_POINT_OF_INTEREST_ERROR = 'GET_POINT_OF_INTEREST_ERROR';
export const GET_GATEWAY_SEARCH = 'GET_GATEWAY_SEARCH';
export const GET_GATEWAY_SEARCH_ERROR = 'GET_GATEWAY_SEARCH_ERROR';
export const GET_GATEWAY_ACTIVITY_PASSES = 'GET_GATEWAY_ACTIVITY_PASSES_PASSES';
export const GET_GATEWAY_ACTIVITY_PASSES_ERROR = 'GET_GATEWAY_ACTIVITY_PASSES_ERROR';
export const GET_GATEWAY_TREE_PERMITS = 'GET_GATEWAY_TREE_PERMITS';
export const GET_GATEWAY_TREE_PERMITS_ERROR = 'GET_GATEWAY_TREE_PERMITS_ERROR';

// lookup actions
export const GET_LOOKUP = 'GET_LOOKUP';
export const GET_LOOKUP_ERROR = 'GET_LOOKUP_ERROR';
export const CAMPSITE_DETAILS_LABELS_LOOKUP = 'campsite_details_labels';

// holiday actions
export const GET_HOLIDAYS = 'GET_HOLIDAYS';
export const GET_HOLIDAYS_ERROR = 'GET_HOLIDAYS_ERROR';

// Recommendations actions
export const RECOMMENDATION_FAILED = 'RECOMMENDATION_FAILED';
export const RECOMMENDATION_RESULTS = 'RECOMMENDATION_RESULTS';

// Page Flags
export const HOME_PAGE = 'Home_Page';
export const CAMPSITE_PAGE = 'Campsite_Page';
export const CAMPGROUND_PAGE = 'Campground_Page';
export const CAMPGROUND_AVAILABILITY_PAGE = 'Campground_Availability_Page';

// launch darkly flags
export const MAP_PROVIDER_FEATURE = 'map-provider';
export const SHOW_CAMPSITE_PAGE_IMAGES = 'show-campsite-page-images';
export const SHOW_CAMPGROUND_PAGE_IMAGES = 'show-campground-page-images';
export const SHOW_CAMPSITE_SEARCH_RESULTS_IMAGES = 'show-campsite-search-results-images';
export const SHOW_CAMPGROUND_SEARCH_RESULTS_IMAGES =
    'show-campground-search-results-images';
export const SHOW_MAP_OVERLAY_IMAGES = 'show-map-overlay-images';
export const ALLOW_VIEW_EXISTING_RESERVATIONS = 'allow-view-existing-reservations';

// Change MapBox Zoom Behavior
export const ENABLE_SCROLL_ZOOMING = 'enable-scroll-zooming';
export const DISABLE_SCROLL_ZOOMING = 'disable-scroll-zooming';

// Number of days should be displayed in campground-availability page.
export const NUMBER_OF_DAYS_DISPLAYED_AVAILABILITY_MIN = 10;
export const NUMBER_OF_DAYS_DISPLAYED_AVAILABILITY_MAX = 10;
export const NUMBER_OF_DAYS_DISPLAYED_AVAILABILITY_DIFF =
    NUMBER_OF_DAYS_DISPLAYED_AVAILABILITY_MAX - NUMBER_OF_DAYS_DISPLAYED_AVAILABILITY_MIN;
export const NUMBER_OF_DAYS_MOVED = 5;
export const NUMBER_OF_DAYS_DISPLAYED_AVAILABILITY_MONTH = 30;
export const NUMBER_OF_CAMPSITES_DISPLAYED_AVAILABILITY = 25;

export const CREATE_CAMPSITE_RESERVATION = 'CREATE_CAMPSITE_RESERVATION';
export const CREATE_CAMPSITE_RESERVATION_ERROR = 'CREATE_CAMPSITE_RESERVATION_ERROR';

// rentals
export const GET_RENTAL_EQUIPMENTS = 'GET_RENTAL_EQUIPMENTS';
export const GET_RENTAL_EQUIPMENTS_ERROR = 'GET_RENTAL_EQUIPMENTS_ERROR';
export const GET_EQUIPMENT_INFO = 'GET_EQUIPMENT_INFO';
export const GET_EQUIPMENT_INFO_ERROR = 'GET_EQUIPMENT_INFO_ERROR';

// Rental Archive?
export const GET_RENTALS_RESERVATION = 'GET_RENTALS_RESERVATION';
export const GET_RENTALS_RESERVATION_ERROR = 'GET_RENTALS_RESERVATION_ERROR';
export const UPDATE_RENTALS_RESERVATION = 'UPDATE_RENTALS_RESERVATION';
export const UPDATE_RENTALS_RESERVATION_ERROR = 'UPDATE_RENTALS_RESERVATION_ERROR';
export const CREATE_RENTALS_RESERVATION = 'CREATE_RENTALS_RESERVATION';
export const CREATE_RENTALS_RESERVATION_ERROR = 'CREATE_RENTALS_RESERVATION_ERROR';
export const SAVE_RENTALS_RESERVATIONS = 'SAVE_RENTALS_RESERVATIONS';
export const GET_RENTAL_EQUIPMENT_INFO = 'GET_RENTAL_EQUIPMENT_INFO';

// amenities
export const GET_AMENITIES = 'GET_AMENITIES';
export const GET_AMENITIES_ERROR = 'GET_AMENITIES_ERROR';

// Continue to external link modal
export const SET_CONTINUE_TO_EXTERNAL_LINK = 'SET_CONTINUE_TO_EXTERNAL_LINK';

// Pass Types
export const FETCH_PASS_TYPES = 'FETCH_PASS_TYPES';
export const FETCH_PASS_TYPES_ERROR = 'FETCH_PASS_TYPES_ERROR';

// Okefenokee
export const OKEFENOKEE_AVAILABILITY_DATE_RANGE_STARTED =
    'OKEFENOKEE_AVAILABILITY_DATE_RANGE_STARTED';
export const OKEFENOKEE_AVAILABILITY_DATE_RANGE_SUCCESS =
    'OKEFENOKEE_AVAILABILITY_DATE_RANGE_SUCCESS';
export const OKEFENOKEE_AVAILABILITY_DATE_RANGE_FAIL =
    'OKEFENOKEE_AVAILABILITY_DATE_RANGE_FAIL';
export const HeadersList = [
    'Distance (miles)',
    'Date',
    'Distance (miles)',
    'Date',
    'Distance (miles)',
    'Date',
    'Distance (miles)',
    'Exit',
];

// Inventory
export const MAP_INVENTORY_FETCHED = 'MAP_INVENTORY_FETCHED';
export const FETCHING_MAP_INVENTORY_FAILED = 'FETCHING_MAP_INVENTORY_FAILED';
export const UPDATE_FILTERED_MAP_INVENTORY = 'UPDATE_FILTERED_MAP_INVENTORY';
export const MAXIMUM_MAP_SEARCH_RESULTS = 200;

export const NonSiteSpecific = {
    name: 'Non Site-Specific',
    id: 2,
};

// Itineraries
export const itineraryIds = [
    { site: 'Pictured Rocks', id: '256367' },
    { site: 'Haleakala', id: '234783' },
    { site: 'Canaveral', id: '251854' },
    { site: 'Cumberland', id: '253730' },
    { site: 'Apostle Islands', id: '251865' },
    { site: 'Voyageurs', id: '249981' },
    { site: 'Okefenokee', id: '250860' },
    { site: 'Saguaro', id: '10028678' },
    { site: 'Big Bend', id: '10028875' },
    { site: 'Mammoth Cave', id: '10048983' },
    { site: 'Hōlua', id: '10119505' },
    { site: 'Palikū', id: '10119569' },
];

export const CAMPSITE_TYPES = {
    MANAGEMENT: 'MANAGEMENT',
};

export const CAMPSITE_RESERVE_TYPES = {
    OVERFLOW: 'Overflow',
    PER_PERSON: 'Per Person',
};

export const TYPE_OF_USE_DAY = 'Day';
export const TYPE_OF_USE_OVERNIGHT = 'Overnight';
export const TYPE_OF_USE_MULTI = 'Multi';

// common date format strings
export const DATE_FORMAT_STANDARD = 'YYYY-MM-DD'; //
export const DATE_FORMAT_US_SLASHES = 'MM/DD/YYYY';
export const DATE_FORMAT_MLA = 'MMMM DD, YYYY';
export const DATE_FORMAT_MLA_ABBREV = 'MMM DD, YYYY';

export const MAX_DATE = '9999-12-31T00:00:00Z';

// Source Types
export const FIELD_SALES_SOURCE = 'Field Sales';
export const CALL_CENTER_SOURCE = 'Call Center';
export const WEB_SOURCE = 'Web';

export const TRUSTED_ORIGINS = [
    'http://localhost:9900',
    'https://www.r1s-dev.com',
    'https://www.r1s-test.com',
    'https://www.recreation.gov',
    'https://cdn.r1s-dev.com',
    'https://cdn.r1s-test.com',
    'https://cdn.recreation.gov',
    'https://www.nps.gov',
];

// events to notify changes to the widget

export const CONTINUE_SHOPPING_EVENT = 'CONTINUE_SHOPPING_EVENT';
export const MODIFY_RESERVATION_EVENT = 'MODIFY_RESERVATION_EVENT';

export const MESSAGE_EVENTS = {
    [CONTINUE_SHOPPING_EVENT]: {
        type: CONTINUE_SHOPPING_EVENT,
        description: 'continue shopping event',
    },
    [MODIFY_RESERVATION_EVENT]: {
        type: MODIFY_RESERVATION_EVENT,
        description: 'modify reservation event',
    },
};

export const HEADER_DESKTOP_HEIGHT = 80;
export const HEADER_MOBILE_HEIGHT = 73;

// camping calendar
export const CAMPGROUND_CALENDAR_ID = 'campground-calendar';

// attribute names (lowercase)
export const HAS_RENTALS = 'has rentals';

// default timezone
export const DEFAULT_TIMEZONE = 'America/New_York';
